import React from 'react';
import PropTypes from 'prop-types';
import styles from '../css/app.css';

const buttonStyle = ({ buttonColor, textColor, isWhiteButton }) => ({
  background: `${buttonColor}`,
  color: `${textColor}`,
  border: isWhiteButton ? `1px solid ${textColor}` : 'none',
});

const buttonHoverStyle = ({ buttonColor, textColor }) => ({
  background: `${textColor}`,
  color: `${buttonColor}`,
  border: `1px solid ${buttonColor}`,
});

const buttonFocusStyle = {
  boxShadow: '#ABB7FF 0px 0px 0px 3px',
};

const getButtonStyle = ({ state, buttonColor, textColor }) => {
  const isWhiteButton = buttonColor ? buttonColor.toLowerCase() === '#ffffff' : false;
  let style = buttonStyle({ buttonColor, textColor, isWhiteButton });
  if (state.focus) {
    style = { ...style, ...buttonFocusStyle };
  }
  if (state.hover) {
    style = { ...style, ...buttonHoverStyle({ buttonColor, textColor }) };
  }
  return style;
};

class CustomButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hover: false, active: false };
  }

  render () {
    var {
      url, text, buttonColor, textColor,
    } = this.props;

    return (
      <a
        className={styles.custom_button}
        style={getButtonStyle({ state: this.state, buttonColor, textColor })}
        href={url}
        onFocus={() => this.setState({ focus: true })}
        onBlur={() => this.setState({ focus: false })}
        onMouseOver={() => this.setState({ hover: true })}
        onMouseOut={() => this.setState({ hover: false })}
      >
        {text}
      </a>
    );
  }
}

CustomButton.propTypes = {
  links: PropTypes.shape({
    custom_links_color: PropTypes.string,
    custom_links_contrast_color: PropTypes.string,
    custom_links: PropTypes.array,
  }).isRequired,
  buttonColor: PropTypes.string.isRequired,
  textColor: PropTypes.string.isRequired,
};

export default CustomButton;



/** WEBPACK FOOTER **
 ** ./app/webroot/js/instagramBioGrid/components/CustomButton.jsx
 **/